// extracted by mini-css-extract-plugin
module.exports = {"item":"RecipeListCard_item__4Bq8d","info":"RecipeListCard_info__yWosH"};